export const driverLicenseTypes: { [key: string]: string } = {
  ACC: 'ACC - Autorização para conduzir ciclomotor',
  A: 'A - Moto',
  B: 'B - Carro',
  C: 'C - Caminhão',
  D: 'D - Ônibus',
  E: 'E - Caminhão Pesado',
  AB: 'AB - Moto e Carro',
  AC: 'AC - Moto e Caminhão',
  AD: 'AD - Moto e Ônibus',
  AE: 'AE - Moto e Caminhão Pesado',
};
